import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { RequestUpdateLeaveBalanceDto } from "../dto/leave.dto";

@Injectable()
export class LeaveApi {
  private readonly service: string = '';
  private readonly model: string = 'leave';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public updateLeaveBalance(payload: RequestUpdateLeaveBalanceDto) {
    const method: string = 'POST';
    const func: string = 'updateLeaveBalance';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }




} 


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/leave.api.ts